module.exports = {
      id: "lang-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#lang",
      toString: function () {
        return this.url;
      }
    }